import Chemist from "./Chemist";

export default Chemist;
